import React, { useEffect } from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import "../scss/global.scss"

const IndexPage = () => {

  useEffect(() => {
    // CLEAR ON START - ALWAYS A NEW SESSION
    sessionStorage.clear()
  })

  return (
      <Layout>
          <h2>Welcome to the home of the forms</h2>
          <p>Please use the search above to locate applicable forms or choose from some commonly searched for forms below:</p>
          <ul>
            <li><Link to="/forms/contact-us">Contact Us</Link></li>
          </ul>
      </Layout>
  )
}

export default IndexPage